
import { TranslationService } from "@/core/services/TranslationService";
import { FormatMethods } from "@/helpers/data-format";
import { computed, defineComponent, PropType, toRefs } from "vue";
import VZKeyValue from "@/components/content/VZKeyValue.vue";
import { IEmailConfig } from "@/interfaces/iEmail";
export default defineComponent({
  name: "EmailDetail",
  inheritAttrs: false,
  props: {
    data: { type: Object as PropType<IEmailConfig>, required: true },
  },
  components: { VZKeyValue },
  setup(props) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const { data } = toRefs(props);
    const format = computed(() => {
      return FormatMethods;
    });
    const items = computed(() => {
      const localData = props.data?.data ?? {};
      const dataToKeyValue = Object.keys(localData)?.map((key) => {
        const isBoolean = typeof localData[key] === "boolean";
        let dataValue = localData[key] ?? "";
        if (isBoolean) {
          dataValue = format.value.yesNoToIconPlain(dataValue);
        }
        if (key === "password") {
          dataValue = "********";
        }
        const header = `pages.email.${key}`;
        return {
          header: t(header),
          value: dataValue,
          isHTML: isBoolean,
        };
      });
      return [
        {
          header: t("common.startDate"),
          value: data.value.startDate
            ? format.value.convertUTCToLocalDate(data.value.startDate)
            : "",
        },
        {
          header: t("common.endDate"),
          value: data.value.endDate
            ? format.value.convertUTCToLocalDate(data.value.endDate)
            : "",
        },
        {
          header: t("common.name"),
          value: data.value?.name,
        },
        {
          header: t("common.type"),
          value: data.value.emailProviderCodeText,
        },
        {
          header: t("common.status"),
          value: data.value.status
            ? format.value.TitleCase(data.value.status?.toLowerCase())
            : "",
          valueClass:
            data.value.status?.toLowerCase() === "active"
              ? "badge badge-success bg-success"
              : "badge badge-danger bg-danger",
        },
        ...dataToKeyValue,
        {
          header: t("common.createdDate"),
          value: data.value.createdDate
            ? format.value.convertUTCToLocalDate(
                data.value.createdDate,
                "MM-DD-YYYY hh:mm A"
              )
            : "",
        },
        {
          header: t("common.createdBy"),
          value: data.value.createdBy,
        },
        {
          header: t("common.updatedDate"),
          value: data.value.updateDate
            ? format.value.convertUTCToLocalDate(
                data.value.updateDate,
                "MM-DD-YYYY hh:mm A"
              )
            : "",
        },
        {
          header: t("common.updatedBy"),
          value: data.value.updatedBy,
        },
      ];
    });
    return {
      items,
    };
  },
});
